import { ApiPaths } from './ApiPaths';
import BaseApi from './BaseApi';

/**
 * API for managing workflow information
 * @param {String} baseURL
 */
const create = () => {  // this will change for prod deployment
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create({
        timeout: 60000
    });

    const completePrepareReturnTask = (ticketId, payload) => api.put(ApiPaths.PREPARE_RETURN(ticketId), payload);
    const updatePrepareReturnTask = (ticketId, payload) => api.put(ApiPaths.UPDATE_PREPARE_RETURN(ticketId), payload);
    const resetPrepareReturnTask = (ticketId) => api.deleteRequest(ApiPaths.PREPARE_RETURN(ticketId));

    // Return back a collection of functions
    return {
        completePrepareReturnTask, updatePrepareReturnTask, resetPrepareReturnTask
    }
}

// let's return back our create method as the default.
export default {
    create
}
